var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:['agent-permissions-list', `agent-permissions-list--${_vm.size}`]},_vm._l((_vm.items),function(item){return _c('li',{key:_vm.keyFn(item),staticClass:"agent-permissions-list__item",class:{
      'agent-permissions-list__item--active': _vm.activeFn(item) === _vm.active,
    },on:{"click":function($event){return _vm.$emit('click', item)}}},[_vm._t("default",function(){return [_vm._v("\n      "+_vm._s(item.title)+"\n    ")]},{"item":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }